import React from 'react';
import Layout from './components/Layout';
import SEO from './components/SEO';

const HousePage: React.FC = () => {
  return (
    <Layout>
      <SEO 
        title="noprblm"
        description="noprblm"
        keywords="noprblm"
        canonicalUrl="/house"
      />
      <section className="hero-simple house-hero">
        <div className="container-sm">
          <h1>noprblm</h1>
        </div>
      </section>
      
      <section className="section">
        <div className="container-sm">
          <div className="house-divider"></div>
        </div>
      </section>
    </Layout>
  );
};

export default HousePage;